/**
 * Compatibility shim — legacy pages still import Footer. The new shell
 * (DashboardShell) doesn't need a separate footer, so this renders nothing.
 */

export default function Footer() {
  return null;
}
